import { useFormContext } from 'react-hook-form'
import BefehlFormAuftrag from '../../Generic/BefehlFormAuftrag'
import { useTranslation } from 'react-i18next'

export interface AuftragX_25FormProps {
  befehlKennung: string
  fieldNamePrefix: string
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings?: boolean
}

export default function AuftragX_25Form({
  befehlKennung,
  fieldNamePrefix,
  readOnly,
  'data-testid': testId
}: Readonly<AuftragX_25FormProps>) {
  const formMethods = useFormContext()
  const { control } = formMethods
  const { t } = useTranslation('ui-befehle')

  const auftragFormFieldName = `${fieldNamePrefix}.enabled`

  const isFreitextEnabled = formMethods.watch(auftragFormFieldName)

  const displayAuftragKennung = isFreitextEnabled
    ? `${befehlKennung}.25`
    : 'x.25'

  return (
    <BefehlFormAuftrag
      auftragKennung={`${befehlKennung}.25`}
      displayKennung={displayAuftragKennung}
      fieldName={auftragFormFieldName}
      control={control}
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={false}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.x_25.label')}</span>
    </BefehlFormAuftrag>
  )
}
